export default __webpack_public_path__ + "static/media/GreenInterest.2b416ffe.svg";